<template>
  <b-card
    no-body
    class="report-funnel"
  >
    <b-card-body>
      <h4 class="mb-25">
        {{ title }}
      </h4>
      <div class="report-funnel__subtitle mb-1">
        {{ subtitle || 'نرخ عبور از هر مرحله به مرحله‌ی بعد' }}
      </div>

      <div
        class="report-funnel__body"
        :class="{ 'report-funnel__body--busy': loading }"
      >
        <div
          v-if="steps.length"
          class="report-funnel__steps"
        >
          <div
            v-for="(step, index) in steps"
            :key="step.Key"
            class="report-funnel__step"
          >
            <div class="report-funnel__head">
              <span class="report-funnel__name">{{ step.Title }}</span>
              <!-- مقدار همیشه به‌صورت برچسب مستقیم نوشته می‌شود، نه فقط در تولتیپ -->
              <span class="report-funnel__count">{{ group(step.Value) }}</span>
            </div>

            <div class="report-funnel__track">
              <div
                class="report-funnel__fill"
                :style="{ width: `${widthOf(step)}%`, background: colorOf(index) }"
              />
            </div>

            <div class="report-funnel__rates">
              <span v-if="step.StepRate !== null && step.StepRate !== undefined">
                <feather-icon
                  icon="CornerDownLeftIcon"
                  size="12"
                />
                {{ round(step.StepRate) }}٪ از مرحله‌ی قبل
              </span>
              <span
                v-if="index > 0 && step.TotalRate !== null && step.TotalRate !== undefined"
                class="report-funnel__total"
              >{{ round(step.TotalRate) }}٪ از کل</span>
            </div>
          </div>
        </div>

        <div
          v-else
          class="report-funnel__empty"
        >
          <feather-icon
            icon="FilterIcon"
            size="26"
          />
          <p class="mt-1 mb-0">
            داده‌ای برای این بازه وجود ندارد
          </p>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCardBody } from 'bootstrap-vue'
import { sequential } from './theme'

export default {
  name: 'ReportFunnel',
  components: { BCardBody },
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'قیف تبدیل',
    },
    subtitle: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    skin: {
      type: String,
      default: 'light',
    },
  },
  computed: {
    max() {
      return this.steps.reduce((acc, s) => Math.max(acc, s.Value), 0)
    },
  },
  methods: {
    widthOf(step) {
      if (!this.max) return 0
      // حداقل ۱.۵٪ تا مرحله‌ی بسیار کوچک هم دیده شود
      return Math.max((step.Value / this.max) * 100, step.Value > 0 ? 1.5 : 0)
    },

    /**
     * مراحل قیف یک مقیاس ترتیبی‌اند (نه دسته‌های اسمی)، پس رمپ تک‌رنگ
     * درست است. روشن‌ترین پله را استفاده نمی‌کنیم تا روی سطح روشن هم
     * کنتراست ۲:۱ حفظ شود.
     */
    colorOf(index) {
      const ramp = sequential(this.skin)
      const usable = ramp.slice(3)
      const span = Math.max(this.steps.length - 1, 1)
      const position = Math.round((index / span) * (usable.length - 1))

      return usable[position]
    },

    round(value, digits = 1) {
      const factor = 10 ** digits
      return Math.round(value * factor) / factor
    },

    group(value) {
      return String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
}
</script>

<style lang="scss" scoped>
.report-funnel {
  height: 100%;

  &__subtitle {
    font-size: 0.75rem;
    color: #b9b9c3;
  }

  &__body {
    transition: opacity 0.15s ease;

    &--busy {
      opacity: 0.45;
    }
  }

  &__step + &__step {
    margin-top: 1rem;
  }

  &__head {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 0.3rem;
  }

  &__name {
    font-size: 0.82rem;
  }

  &__count {
    font-size: 0.9rem;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
  }

  &__track {
    height: 10px;
    border-radius: 5px;
    background: rgba(115, 103, 240, 0.1);
    overflow: hidden;
  }

  &__fill {
    height: 100%;
    border-radius: 5px;
    transition: width 0.35s ease;
  }

  &__rates {
    margin-top: 0.3rem;
    font-size: 0.7rem;
    color: #b9b9c3;
  }

  &__total {
    margin-right: 0.75rem;
  }

  &__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #b9b9c3;
    font-size: 0.85rem;
    padding: 2.5rem 0;
  }
}
</style>
